export const config = {
  iamUrl: import.meta.env.VITE_IAM_URL || 'https://persona.applica.guru/iam',
  coreApiUrl: import.meta.env.VITE_CORE_API_URL || 'https://persona.applica.guru/api',
  workflowsUrl: import.meta.env.VITE_WORKFLOWS_URL || 'https://persona.applica.guru/workflows',
  billingUrl: import.meta.env.VITE_BILLING_URL || 'https://persona.applica.guru/billing',
  chatUrl: import.meta.env.VITE_CHAT_URL || 'https://persona.applica.guru/chat',
  chatBaseUrl: import.meta.env.VITE_CHAT_BASE_URL || 'persona.applica.guru/api',
  port: parseInt(import.meta.env.VITE_PORT || '3000', 10),
  // Google's OAuth client_id/client_secret for the Credentials feature are fixed
  // server-side (persona-core env vars), not configured here — client_secret must never
  // be bundled into frontend JS.
  googleOAuthDefaultScope: import.meta.env.VITE_GOOGLE_OAUTH_DEFAULT_SCOPE || 'https://www.googleapis.com/auth/gmail.readonly',
} as const

const GOOGLE_CLIENT_IDS = {
  localhost: '44115216760-qkndqrnhf8splber2i98m22sib525cae.apps.googleusercontent.com',
  production: '947884919203-jqf9sb2nia2pkf89mjg4llaou1peu1iq.apps.googleusercontent.com',
} as const

export function getGoogleClientId(): string {
  const host = window.location.host
  if (host.includes('localhost:3000') || host.includes('localhost:3001')) {
    return GOOGLE_CLIENT_IDS.localhost
  }
  return GOOGLE_CLIENT_IDS.production
}
